import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import DisconnectCalDialogStrings from './strings';
import { Subject } from 'rxjs';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter
} from '@ps-design-system/components/Dialog';
import { Button } from '@ps-design-system/components/Button';
import { Text } from '@ps-design-system/components/Text';
import { toast } from '@ps-design-system/components/Toast';
import useSyncFlowAnalytics from '../../../sync-flow-v2/hooks/useSyncFlowAnalytics';

export const DisconnectCalEventSubject$ = new Subject();

const DisconnectCalDialog = ({
  isOpen,
  onOpenChange
}) => {
  const { disconnectSyncedCalendar } = useCalendarStore();
  const isDisconnectingCal = useCalendarStore(state => state.isDisconnectingCal);

  const { TrackCalendarDisconnected } = useSyncFlowAnalytics();

  useEffect(() => {
    const subscription = DisconnectCalEventSubject$.subscribe((event) => {
      if ('error' === event.type) {
        toast({
          title: '',
          description: DisconnectCalDialogStrings.disconnectError,
          variant: 'destructive',
          duration: 5000
        });
        onOpenChange(false);
      }

      if ('success' === event.type) {
        TrackCalendarDisconnected();
        location.reload();
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="DisconnectCalDialogContent" size="sm">
        <DialogHeader headerAlignment="left">
          <DialogTitle className="DisconnectCalDialogContent_dialog_title">
            {DisconnectCalDialogStrings.title}
          </DialogTitle>
        </DialogHeader>

        <DialogBody>
          <Text variant="caption-2-m">
            {DisconnectCalDialogStrings.description}
          </Text>
        </DialogBody>

        <DialogFooter>
          <div className="DisconnectCalDialogButtons">
            <div className="DisconnectCalDialogButtons_button">
              <Button variant="underline" onClick={() => onOpenChange(false)}>
                {DisconnectCalDialogStrings.cancel}
              </Button>
            </div>
            <Button
              onClick={disconnectSyncedCalendar}
              showSpinner={isDisconnectingCal}
              className="DisconnectCalDialogButtons_button"
            >
              {DisconnectCalDialogStrings.confirm}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

DisconnectCalDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired
};

export default DisconnectCalDialog;
